module.exports = __webpack_public_path__ + "img/salespersonTuanDui.8e8f641a.png";